export default "__VITE_ASSET__035169d1__"